import { useRecoilValue } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import useGoogleLoginV6 from "../../hooks/useGoogleLoginV6";
import LoginButtonTemplatePromotion from "./LoginButtonTemplatePromotion";
import useMixpanelMKT from "../../hooks/useMixpanelMKT";

export default function GoogleLoginButtonV6({
  render,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
}) {
  const user = useRecoilValue(userSimpleAtom);
  const { handleGoogleLogin, isLoading } = useGoogleLoginV6();

  const trackLoginButtonClick = useMixpanelMKT({
    eventName: "로그인 버튼 클릭",
    params: { method: "google" },
    version: "v6",
  });

  return (
    <LoginButtonTemplatePromotion
      loginType="google"
      action={() => {
        trackLoginButtonClick();
        handleGoogleLogin();
      }}
      isLoggedIn={!!user?.accessToken}
      isLoading={isLoading}
    />
  );
}
